export default __webpack_public_path__ + "static/media/Screenshot (105).8afe7354.png";